<template>
  <!-- 委托管理页面 -->
  <div class="entrust-page">
    <!-- 顶部 Tab 切换 -->
    <div class="page-header">
      <el-radio-group v-model="form.type" @change="storeage" size="medium">
        <el-radio-button label="1">买入委托记录</el-radio-button>
        <el-radio-button label="2">卖出委托记录</el-radio-button>
      </el-radio-group>
    </div>

    <!-- 筛选区 -->
    <el-card class="filter-card" shadow="never">
      <div class="filter-row">
        <el-date-picker
          v-model="value"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          @change="pickerChange"
          class="filter-item filter-date"
          clearable>
        </el-date-picker>
        <el-input
          v-model="form.userId"
          placeholder="请输入Uid"
          clearable
          class="filter-item">
        </el-input>
        <el-select
          v-model="form.finish"
          placeholder="请选择状态"
          clearable
          class="filter-item">
          <el-option v-for="item in finish" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-select
          v-model="form.certificateId"
          placeholder="请选择交易数字通证"
          clearable
          class="filter-item filter-token">
          <el-option v-for="item in selectBox" :key="item.certificateId" :label="item.tokenName"
            :value="item.certificateId"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="onSearch">搜索</el-button>
        <el-button type="success" icon="el-icon-document" @click="exportData">生成表格</el-button>
        <download-excel v-if="derivedForm" class="export" :data="derivedForm" :fields="jsonFields" type="xls"
          name="委托管理表.xls">
          下载表格
        </download-excel>
      </div>
    </el-card>

    <!-- 撤销 GEN 委托 -->
    <el-card class="action-card" shadow="never">
      <div class="action-row">
        <span class="action-title">GEN 委托操作：</span>
        <el-input
          v-model="cancelEntrustId"
          placeholder="输入委托id"
          clearable
          class="action-input">
        </el-input>
        <el-button type="danger" icon="el-icon-close" @click="cancelGenEntrust">撤销GEN委托</el-button>
      </div>
    </el-card>

    <!-- 数据统计 -->
    <div class="statistical">
      <span class="statistical-title">委托买入/卖出剩余数量统计：</span>
      <span class="statistical-item">买入金额：<b>{{ statistical.buyAmount || 0 }}</b></span>
      <span class="statistical-item">买入数量：<b>{{ statistical.buyNum || 0 }}</b></span>
      <span class="statistical-item">卖出金额：<b>{{ statistical.saleAmount || 0 }}</b></span>
      <span class="statistical-item">卖出数量：<b>{{ statistical.saleNum || 0 }}</b></span>
    </div>

    <!-- 表格 -->
    <el-table :data="data" border stripe class="entrust-table">
      <el-table-column prop="userId" label="UID" align="center" min-width="100"></el-table-column>
      <el-table-column prop="orderSn" label="订单编号" width="190" align="center"></el-table-column>
      <el-table-column prop="tokenName" label="数字通证名称" width="120" align="center"></el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.type == 1 ? 'success' : 'warning'" size="small">
            {{ scope.row.type == 1 ? '买入委托' : '卖出委托' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="num" label="真实委托量" align="center"></el-table-column>
      <el-table-column prop="residueNum" label="剩余数量" align="center"></el-table-column>
      <el-table-column prop="price" label="委托单价" align="center"></el-table-column>
      <el-table-column prop="totalPrice" label="委托总价" align="center"></el-table-column>
      <el-table-column prop="createTime" label="计划时间" align="center" width="160"></el-table-column>
      <el-table-column prop="finish" label="状态" align="center" width="100">
        <template slot-scope="scope">
          <el-tag :type="finishTagType(scope.row.finish)" size="small">
            {{ finishText(scope.row.finish) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.finish == 0 || scope.row.finish == 2" type="danger" size="mini"
            @click="chexiao(scope.$index, scope.row.id)">撤销</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部分页 -->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="form.currentPage" :page-sizes="[10, 15, 20, 30]" :page-size="form.pageNumber"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import defaultSettings from '@/settings'
import { xmlUrl } from '../../utils/xmlurl'
export default {
  data() {
    return {
      form: {
        certificateId: null, // 通证ID
        currentPage: 0, // 当前页
        pageSize: 10, // 分页打小
        userId: null, // 电话
        finish: null, // 状态ID
        type: 1 // 类型
      },
      selectBox: '',
      value: [],
      derivedForm: '',
      tabls: true,
      data: [],
      total: null,
      pageNumber: null,
      jsonFields: {
        UID: 'userId',
        订单编号: 'orderSn',
        数字通证名称: 'tokenName',
        类型: 'type',
        真实委托量: 'num',
        剩余数量: 'residueNum',
        委托单价: 'price',
        委托总价: 'totalPrice',
        计划时间: 'createTime',
        状态: 'finish'
      },
      options: '',
      finish: [
        { id: 0, name: '未成交' },
        { id: 1, name: '成交' },
        { id: 2, name: '部分成交' },
        { id: 3, name: '撤销' }
      ],
      statistical: '', // 委托统计
      cancelEntrustId: '' // 撤销GEN委托输入的委托id
    }
  },
  created() {
    this.getData() // 获取数据
    this.getSelectBox() // 获取下拉框
  },
  methods: {
    // 监听时间
    pickerChange(e) {
      if (e) {
        this.form.startTime = e[0]
        this.form.endTime = e[1]
      } else {
        delete this.form.startTime
        delete this.form.endTime
      }
      this.form.currentPage = 1
      this.getData()
    },
    // 搜索
    onSearch() {
      this.form.currentPage = 1
      this.getData()
    },
    // 表格状态文案
    finishText(val) {
      return val == 0 ? '未成交' : val == 1 ? '成交' : val == 2 ? '部分成交' : '撤销'
    },
    // 表格状态 tag 类型
    finishTagType(val) {
      if (val == 0) return 'info'
      if (val == 1) return 'success'
      if (val == 2) return 'warning'
      return 'danger'
    },
    // 撤销 GEN 委托
    cancelGenEntrust() {
      const id = String(this.cancelEntrustId).trim()
      if (!id) {
        this.$message.warning('请输入委托id')
        return
      }
      this.$confirm(`确定撤销委托ID为 ${id} 的GEN委托吗？`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.axios
            .getWithAnyHttpStatus('/admin/genEntrust/updateEntrust', { id })
            .then(res => {
              const d = res.data || {}
              const code = d.code
              if (code == -1 || code === '-1') {
                this.$message.error(d.data || d.mesg || d.message || '操作失败')
                return
              }
              this.$message.success(d.mesg || '操作成功')
              this.cancelEntrustId = ''
              this.getData()
            })
            .catch(() => {
              this.$message.error('网络异常，请稍后重试')
            })
        })
        .catch(() => {
          this.$message.info('已取消操作')
        })
    },
    // 点击table获取不同的数据
    storeage(e) {
      if (e == 1) {
        this.form.type = 1
        this.tabls = true
      } else {
        this.form.type = 2
        this.tabls = false
      }
      // this.form.finish = null;
      // this.form.certificateId = null;
      this.form.currentPage = 0
      this.form.pageSize = 10
      // this.form.tel = null;
      this.getData()
    },
    // 获取数据
    getData() {
      this.axios
        .get('/admin/entrust/findAllByFirmId', this.form)
        .then(res => {
          this.data = res.data.data.page.records
          this.total = res.data.data.page.total

          this.form.currentPage = res.data.data.page.current

          this.form.pageSize = 10
          this.statistical = res.data.data.count
        })
        .catch(err => { })
    },

    // 获取所有需要导出的数据
    exportData() {
      console.log(xmlUrl)
      this.$message.success('生成中，请稍候');
      this.axios.get('/admin/entrust/getAll', this.form).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          setTimeout(function () {
            window.open(xmlUrl + res.data.data)
          }, 5000);
          // window.open(`http://47.109.88.30:9071/${res.data.data}`)
          // window.open(xmlUrl + res.data.data)
        } else {
          console('2222')
        }
      })
      // this.axios.get('/admin/userWater/getTime', {}).then(res => {
      //   if (res.data.code == -1) {
      //     this.axios.get('/admin/entrust/getAll', this.form).then(res => {
      //       console.log(res)
      //       if (res.data.code == 200) {
      //         window.open(`http://47.109.88.30:9071/${res.data.data}`)
      //       } else {
      //         console('2222')
      //       }
      //     })

      //     // 注释这里的原因是后端说这个接口太耗资源，该用列表接口
      //     // this.axios.get('/admin/userWithdraw/withdrawExcel', {}).then(res => {
      //     // this.form.pageSize = 200
      //     // this.axios.get('/admin/entrust/findAllByFirmId', this.form).then(res => {
      //     //   console.log(res)
      //     //   // this.derivedForm = res.data.data
      //     //   this.form.pageSize = 10
      //     //   this.derivedForm = res.data.data.page.records
      //     //   this.derivedForm.forEach(item => {
      //     //     item.finish = item.finish == 0 ? '未成交' : item.finish == 1 ? '成交' : item.finish == 2 ? '部分成交' : '撤销'
      //     //     item.type = item.type == 1 ? '买入委托' : '卖出委托'
      //     //   })
      //     // })
      //   } else {
      //     this.$message.error('本时段无法生成表格')
      //   }
      // })
    },

    // 获取下拉框
    getSelectBox() {
      this.axios.get('/admin/certificate/getDropDownBox', {}).then(res => {
        this.selectBox = res.data.data
      })
    },

    // 撤销
    chexiao(index, id) {
      // 调用弹窗 提示用户是否确认取消
      this.$confirm('确定撤销委托吗？', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // this.undo();
          // 判断用户点击的是委托记录还是计划委托记录
          if (this.tabls) {
            // 委托记录
            this.axios.get('/admin/entrust/updateFinish', { id }).then(res => {
              if (res.data.code == 200) {
                this.getData()
                this.$message({
                  type: 'success',
                  message: res.data.mesg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.data
                })
              }
            })
          } else {
            // 计划委托记录
            this.axios.get('/admin/entrust/updateFinish', { id }).then(res => {
              if (res.data.code == 200) {
                this.getData()
                this.$message({
                  type: 'success',
                  message: res.data.mesg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.data.data
                })
              }
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销'
          })
        })
    },
    // 分页
    handleSizeChange(val) {
      this.pageNumber = val
      if (this.tabls) {
        this.axios
          .get('/admin/entrust/findAllByFirmId', {
            type: 1,
            pageNumber: this.currentPage,
            pageSize: this.pageNumber,
            certificateId: this.form.certificateId,
            userId: this.form.userId,
            finish: this.form.finish
          })
          .then(res => {
            this.data = res.data.data.page.records
          })
      } else {
        this.axios
          .get('/admin/entrust/findAllByFirmId', {
            type: 2,
            pageNumber: this.currentPage,
            pageSize: this.pageNumber,
            certificateId: this.form.certificateId,
            userId: this.form.userId,
            finish: this.form.finish
          })
          .then(res => {
            this.data = res.data.data.page.records
          })
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      if (this.tabls) {
        this.axios
          .get('/admin/entrust/findAllByFirmId', {
            type: 1,
            currentPage: this.currentPage,
            pageSize: this.pageNumber,
            certificateId: this.form.certificateId,
            userId: this.form.userId,
            finish: this.form.finish
          })
          .then(res => {
            console.log(res)
            this.data = res.data.data.page.records
          })
      } else {
        this.axios
          .get('/admin/entrust/findAllByFirmId', {
            type: 2,
            currentPage: this.currentPage,
            pageSize: this.pageNumber,
            certificateId: this.form.certificateId,
            userId: this.form.userId,
            finish: this.form.finish
          })
          .then(res => {
            this.data = res.data.data.page.records
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.entrust-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100%;
  box-sizing: border-box;
}

.page-header {
  margin-bottom: 16px;
}

/* 筛选区 */
.filter-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;

  ::v-deep .el-card__body {
    padding: 18px 20px;
  }
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.filter-item {
  width: 200px;
}

.filter-date {
  width: 280px;
}

.filter-token {
  width: 220px;
}

/* 撤销 GEN 委托 区 */
.action-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
  background: linear-gradient(90deg, #fff7f7 0%, #ffffff 100%);

  ::v-deep .el-card__body {
    padding: 16px 20px;
  }
}

.action-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-title {
  font-size: 14px;
  color: #f56c6c;
  font-weight: 600;
  white-space: nowrap;
}

.action-input {
  width: 240px;
}

/* 数据统计 */
.statistical {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 14px 20px;
  margin-bottom: 16px;
  background-color: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  font-size: 14px;
}

.statistical-title {
  color: #303133;
  font-weight: 600;
  margin-right: 12px;
}

.statistical-item {
  margin-right: 28px;
  color: #606266;

  b {
    color: #409eff;
    font-weight: 600;
    margin-left: 4px;
  }
}

/* 表格 */
.entrust-table {
  border-radius: 8px;
  overflow: hidden;
}

/* 分页 */
.pagination {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* 导出按钮 */
.export {
  color: #fff;
  background-color: #409eff;
  height: 40px;
  padding: 0 16px;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  font-size: 14px;
  cursor: pointer;
  display: inline-block;

  &:hover {
    background-color: #66b1ff;
  }
}
</style>
